import * as React from "react";
const IconJp = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 0h512v342H0z" />
    <circle cx={256.5} cy={171} r={96}  />
  </svg>
);
export default IconJp;
